import React from "react";
import "./css/ResponseStatus.css";

function ResponseStatus({ children, status }) {
  if (!children || !status) return;
  return (
    <div className={`response-status ${status}`}>
      <p>{children}</p>
    </div>
  );
}

export default ResponseStatus;
